export default defineNuxtPlugin(() => {
  const loadSvgIconCss = () => {
    void import('~/css/additional-styles/svg-icon.css')
  }

  const scheduleAfterLoad = () => {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(loadSvgIconCss, { timeout: 6000 })
      return
    }

    window.setTimeout(loadSvgIconCss, 4000)
  }

  if (document.readyState === 'complete') {
    scheduleAfterLoad()
    return
  }

  window.addEventListener('load', scheduleAfterLoad, { once: true })
})
